import { useEffect, useMemo } from 'react';

import { useInvestmentsFieldsSetter } from '@/modules/investments/StartInvesting/hooks';

import { InvestmentPaths, Investor, InvestorDto } from '../investments.types';
import { useInvestorByIdQuery } from '../queries';
interface Params {
  isSwitchMode?: boolean;
}
export default (params?: Params) => {
  const { handleSetValues } = useInvestmentsFieldsSetter(params);
  const { data: investor, isLoading, isSuccess } = useInvestorByIdQuery();

  const formatData = (data?: InvestorDto): Investor => ({
    investorId: `${data?.account?.investor_id || data?.investor_id || data?.id || ''}`,
    status: data?.status,
    investorBalance: data?.account?.balance || 0,
    toleranceModel:
      data?.investor_profile?.tolerance_model || data?.investor_profile?.proposed_tolerance_model,
    investorAccountId: `${data?.account?.id || ''}`,
    investorEnrollmentId: `${data?.account?.account_id || ''}` || `${data?.account_id || ''}`,
    currentToleranceModel:
      data?.type === InvestmentPaths.MANAGED ? data?.investor_profile?.tolerance_model : '',
    type: data?.type as InvestmentPaths,
    pendingTradesAmount: (data?.account?.sell_pending_amount || 0) + (data?.account?.buy_pending_amount || 0),
    investorAccountStatus: data?.account?.status,
    isInvestmentModelSwitching: data?.investment_model_switching || false,
    cashBalance: data?.account?.cash_balance || 0,
    equityValue: data?.account?.equity_value || 0,
    initialInvestmentAmount: data?.initial_investment_amount,
    amountsGroupedByInstrumentIds: data?.amounts_grouped_by_instrument_ids,

    id: data?.id,
    investorExternalId: data?.employee_id,
    accountId: data?.account_id,
    externalNumber: data?.account?.external_number,
    balance:
      (data?.account?.equity_value || 0) + (data?.account?.cash_balance || 0) ||
      data?.initial_investment_amount,
    riskProductExternalId: data?.account?.ria_product_external_id,
    riskUserExternalId: data?.account?.ria_user_external_id,
    accountStatus: data?.account?.status,
    age: data?.age,
    employeeId: data?.employee_id,
    position: data?.employment_profile?.position,
    employmentType: data?.employment_profile?.employment_type,
    broker: data?.employment_profile?.broker,
    director_of: data?.employment_profile?.director_of,
    politically_exposed_names: data?.employment_profile?.politically_exposed_names,
    accountExternalId: `${data?.external_id || ''}`,
    investmentObjectivesType: data?.investor_profile?.investment_objectives_type,
    investmentExperienceType: data?.investor_profile?.investment_experience_type,
    annualIncome: data?.investor_profile?.annual_income,
    networthTotal: data?.investor_profile?.networth_total,
    purposeType: data?.investor_profile?.purpose_type,
    medicalExpensesCoverType: data?.investor_profile?.medical_expenses_cover_type,

    riskTolerance: data?.investor_profile?.risk_tolerance,
    proposedToleranceModel: data?.investor_profile?.proposed_tolerance_model,
    investorStatus: data?.status,

    employmentProfile: !!data?.employment_profile,
  });
  const formattedData = useMemo(() => {
    return formatData(investor?.data as unknown as InvestorDto);
  }, [investor]);
  useEffect(() => {
    handleSetValues(formattedData);
  }, [handleSetValues, formattedData]);

  return {
    data: formattedData,
    isLoading,
    isSuccess,
  };
};
